module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer3_no-inverter_lt 2.075c85a9.svg";